module.exports = __webpack_public_path__ + "static/media/CUYA_Web_LandingPage_Header_VideoPlaceholder.55b6f190.jpg";